import { useQueryClient } from 'react-query'
import { getValueMessageLinkedDataQueryKey } from './useGetValueMessageLinkedDataQuery'

export const useInvalidateGetValueMessageLinkedDataQuery = () => {
    const queryClient = useQueryClient()

    const invalidateGetValueMessageLinkedDataQuery = async () => {
        await queryClient.invalidateQueries(getValueMessageLinkedDataQueryKey())
    }

    return { invalidateGetValueMessageLinkedDataQuery }
}
